// extracted by mini-css-extract-plugin
export default {"cell":"GridCell_cell__+Djt4","icon":"GridCell_icon__eSWT9"};